import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap"

const StaffModal = ({
  open,
  toggle,
  selectedStaff,
  setSelectedStaff,
  viewOnly,
  onSubmit,
  roles,
}) => {
  const [errors, setErrors] = useState({})

  useEffect(() => {
    setErrors({})
  }, [selectedStaff])

  const handleChange = (field, value) => {
    setSelectedStaff(prev => ({ ...prev, [field]: value }))
    setErrors(prev => ({ ...prev, [field]: "" }))
  }

  const allowOnlyNumbers = e => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "")
  }

  const validate = () => {
    const newErrors = {}

    if (!selectedStaff?.name?.trim()) {
      newErrors.name = "Name is required"
    }

    // if (!selectedStaff?.email?.trim()) {
    //   newErrors.email = "Email is required"
    // } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(selectedStaff.email)) {
    //   newErrors.email = "Invalid email address"
    // }

    if (selectedStaff.phone && selectedStaff.phone.length !== 10) {
      newErrors.phone = "Phone number must be 10 digits"
    }

    if (!selectedStaff?.roleId) {
      newErrors.roleId = "Role is required"
    }

    // if (!selectedStaff?.designation?.trim()) {
    //   newErrors.designation = "Designation is required"
    // }

    if (!selectedStaff?.id && !selectedStaff?.password) {
      newErrors.password = "Password is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (!validate()) return
    onSubmit()
  }

  const renderError = field =>
    errors[field] && (
      <div className="invalid-feedback d-block">{errors[field]}</div>
    )

  const invalid = field => (errors[field] ? "is-invalid" : "")

  return (
    <Modal isOpen={open} centered size="xl" toggle={toggle}>
      <ModalHeader toggle={toggle} >
        {viewOnly
          ? "View Staff"
          : selectedStaff?.id
            ? "Edit Staff"
            : "Add Staff"}

        <div>
          {!viewOnly && (
          <Button className="modal-btn" onClick={handleSubmit}>
            {selectedStaff?.id ? "Update" : "Submit"}
          </Button>
        )}
        </div>
      </ModalHeader>

      <ModalBody>
        <Form>
          <Row>
            {/* Name */}
            <Col md={6}>
              <FormGroup>
                <Label>
                  Name <span className="text-danger">*</span>
                </Label>
                <Input
                  value={selectedStaff?.name || ""}
                  onChange={e => handleChange("name", e.target.value)}
                  disabled={viewOnly}
                  placeholder="Enter full name"
                  className={`form-control rounded-4 ${invalid("name")}`}
                />
                {renderError("name")}
              </FormGroup>
            </Col>

            {/* Email */}
            <Col md={6}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  type="email"
                  value={selectedStaff?.email || ""}
                  onChange={e => handleChange("email", e.target.value)}
                  disabled={viewOnly}
                  placeholder="Enter email address"
                  autoComplete="off"
                  className={`form-control rounded-4 ${invalid("email")}`}
                />
                {renderError("email")}
              </FormGroup>
            </Col>

            {/* Phone */}
            <Col md={6}>
              <FormGroup>
                <Label>Phone Number</Label>
                <Input
                  value={selectedStaff?.phone || ""}
                  maxLength={10}
                  onChange={e => {
                    allowOnlyNumbers(e)
                    handleChange("phone", e.target.value)
                  }}
                  disabled={viewOnly}
                  placeholder="Enter 10-digit phone number"
                  className={`form-control rounded-4`}
                />
              </FormGroup>
            </Col>

            {/* Role */}
            <Col md={6}>
              <FormGroup>
                <Label>
                  Role <span className="text-danger">*</span>
                </Label>
                <Input
                  type="select"
                  value={selectedStaff?.roleId || ""}
                  onChange={e => handleChange("roleId", e.target.value)}
                  disabled={viewOnly}
                  className={`form-control rounded-4 ${invalid("roleId")}`}
                >
                  <option value="">Select Role</option>
                  {roles.map(r => (
                    <option key={r.id} value={r.id}>
                      {r.roleName}
                    </option>
                  ))}
                </Input>
                {renderError("roleId")}
              </FormGroup>
            </Col>

            {/* Designation */}
            {/* <Col md={6}>
              <FormGroup>
                <Label>Designation</Label>
                <Input
                  value={selectedStaff?.designation || ""}
                  onChange={e => handleChange("designation", e.target.value)}
                  disabled={viewOnly}
                  placeholder="Enter full designation"
                  className={`form-control rounded-4 ${invalid("designation")}`}
                />
                {renderError("designation")}
              </FormGroup>
            </Col> */}

            {/* Password */}
            {!viewOnly && (
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Password <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="password"
                    onChange={e => handleChange("password", e.target.value)}
                    disabled={viewOnly}
                    placeholder="Enter password"
                    autoComplete="new-password"
                    className={`form-control rounded-4 ${invalid("password")}`}
                  />
                  {renderError("password")}
                </FormGroup>
              </Col>
            )}

            {/* Address */}
            <Col md={12}>
              <FormGroup>
                <Label>Address</Label>
                <Input
                  type="textarea"
                  rows={3}
                  value={selectedStaff?.address || ""}
                  onChange={e => handleChange("address", e.target.value)}
                  disabled={viewOnly}
                  placeholder="Enter full address"
                  className={`form-control rounded-4`}
                />
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>

      {/* {!viewOnly && (
        <ModalFooter>
          <Button className="btn-blue" onClick={handleSubmit}>
            {selectedStaff?.id ? "Update" : "Submit"}
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      )} */}
    </Modal>
  )
}

export default StaffModal
